<template>
  <div ref="pic" style="height: 100%; width: 100%;" id="pic"></div>
</template>
<script>
import * as echarts from "echarts";
export default{
  props:{
    option:{
      type:Object,
      default:()=>({})
    
    }
  },
  data(){
    return{
      myChart:null
    }
  },
  mounted(){
    this.initChart()
  },
  watch:{
    option:{
      handler(){
        this.$nextTick(()=>{
        this.initChart()
      }) 
      
      },
      deep:true
      
    }
  },
 methods:{
  initChart(){
    if(this.myChart) this.myChart.dispose()
    this.myChart = echarts.init(this.$refs.pic);
    this.myChart.setOption(this.option);
  }
 }
}
</script>